<template>
  <div>
    <!-- Details -->
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="editAtt"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Edit Attendance</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideAtt()"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="pt-1 pb-1 align-items-center">
          <b-col md="3">
            <b-img
              v-if="attendance.picture == null || attendance.picture == ''"
              src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
              style="width: 100px; height: 100px; object-fit: cover"
            />
            <b-img
              v-else
              :src="attendance.picture"
              style="
                width: 100px;
                height: 100px;
                object-fit: cover;
                border-radius: 50%;
              "
            />
          </b-col>
          <b-col md="8" class="ml-1">
            <h5>Name: {{ attendance.name }}</h5>
            <h5>Father Name: {{ attendance.father_name }}</h5>
            <h5>Gr# {{ attendance.grNo }}</h5>
          </b-col>
          <b-col md="12" class="mt-1">
            <b-form-group
              label="Time"
              invalid-feedback="time is required."
              ref="time"
            >
              <flat-pickr
                v-model="timePicker"
                class="form-control"
                :config="{
                  enableTime: true,
                  noCalendar: true,
                  dateFormat: 'h:i:K',
                }"
                @input="setTime()"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Date"
              invalid-feedback="date is required."
              ref="date"
            >
              <flat-pickr
                ref="date"
                :config="config2"
                v-model="datepickr"
                class="form-control"
                :placeholder="$t('Select Date')"
                @input="setTime()"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" class="mt-1">
            <b-form-group
              label="Select Status"
              invalid-feedback="status is required."
              ref="status"
            >
              <v-select
                ref="status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                v-model="attendance.obj.status"
                :options="statusOptions"
                :reduce="(opt) => opt.value"
                label="name"
                placeholder="select status"
              />
            </b-form-group>
          </b-col>
          <b-col class="mt-1" md="12">
            <b-button
              variant="success"
              class="mr-1 fullWidth"
              @click="saveAttendance()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else> Save </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility2"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Send Messsage</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility2 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="pt-1 pb-1 align-items-center">
          <b-col md="12">
            <b-form-group
              :label="$t('Select ' + getLabel('Class'))"
              :invalid-feedback="$t(getLabel('Class') + ' is required')"
              ref="msg_class"
            >
              <v-select
                ref="msg_class"
                multiple
                :closeOnSelect="false"
                v-model="msgClass"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="classesOptions"
                :clearable="false"
                label="name"
                :reduce="(val) => val.id"
                @input="FillMsgSections()"
                :placeholder="$t('Select ' + getLabel('class'))"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" v-if="msgClass[0] != 0">
            <b-form-group
              :label="$t('Select ' + getLabel('Section'))"
              :invalid-feedback="$t(getLabel('Section') + ' is required')"
              ref="msg_section"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                v-model="msgSection"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="msgSecOptions"
                :reduce="(val) => val.id"
                :clearable="false"
                @input="checkMsgSections()"
                ref="msg_section"
                label="section"
                :placeholder="$t('Select ' + getLabel('section'))"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Date"
              invalid-feedback=" date is required."
              ref="msg_date"
            >
              <flat-pickr
                ref="msg_date"
                :config="config"
                v-model="msgObj.dt"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" class="mt-1">
            <b-form-group
              label="Select Status"
              invalid-feedback="status is required."
              ref="msg_status"
            >
              <v-select
                ref="msg_status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                v-model="msgObj.status"
                :options="statusOptions"
                :reduce="(opt) => opt.value"
                label="name"
                placeholder="select status"
              />
            </b-form-group>
          </b-col>
          <b-col class="mt-1" md="12">
            <b-button
              variant="success"
              @click="saveMessage()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else>Send Message</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility3"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Reports</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility3 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="pt-1 pb-1 align-items-center">
          <b-col md="12" v-if="isClasswiseEnrollment">
            <b-form-group
              label="Select Subject"
              invalid-feedback="Subject is required."
            >
              <v-select
                v-model="repEnrolled"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :filterBy="dropFilter"
                :clearable="false"
                :options="enrollOptions"
                label="name"
                placeholder="Select subject and teacher"
                :disabled="enLoading"
              >
                <template #option="option">
                  {{ option.clsName }} ({{ option.secName }}) -
                  {{ option.subName }} - {{ option.name }}
                </template>
                <template #selected-option="option">
                  {{ option.clsName }} ({{ option.secName }}) -
                  {{ option.subName }} - {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <template v-else>
            <b-col md="12">
              <b-form-group
                :label="$t('Select ' + getLabel('Class'))"
                :invalid-feedback="$t(getLabel('Class') + ' is required')"
                ref="rep_class"
              >
                <v-select
                  ref="rep_class"
                  multiple
                  :closeOnSelect="false"
                  v-model="repClass"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="classesOptions"
                  :clearable="false"
                  label="name"
                  :reduce="(val) => val.id"
                  @input="FillRepSections()"
                  :placeholder="$t('Select ' + getLabel('class'))"
                />
              </b-form-group>
            </b-col>
            <b-col md="12" v-if="repClass[0] != 0">
              <b-form-group
                :label="$t('Select ' + getLabel('Section'))"
                :invalid-feedback="$t(getLabel('Section') + ' is required')"
                ref="rep_section"
              >
                <v-select
                  multiple
                  :closeOnSelect="false"
                  v-model="repSection"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="repSecOptions"
                  :reduce="(val) => val.id"
                  :clearable="false"
                  @input="checkRepSections()"
                  ref="rep_section"
                  label="section"
                  :placeholder="$t('Select ' + getLabel('section'))"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Select Subject"
                invalid-feedback="Subject is required."
                ref="rep_sub"
              >
                <v-select
                  v-model="repObj.subID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="[{ id: 0, subject: 'None' }, ...subjects]"
                  :reduce="(val) => val.id"
                  :clearable="false"
                  label="subject"
                  placeholder="Select subject"
                />
              </b-form-group>
            </b-col>
          </template>
          <b-col md="12">
            <b-form-group
              label="Date"
              invalid-feedback=" date is required."
              ref="rep_date"
            >
              <flat-pickr
                ref="rep_date"
                :config="config2"
                v-model="repDate"
                class="form-control"
                :placeholder="$t('Select Date')"
                @on-change="setRepDate"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" class="mt-1">
            <b-form-group
              label="Select Status"
              invalid-feedback="status is required."
              ref="rep_status"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                ref="rep_status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                v-model="repObj.status"
                :options="statusOptions"
                :reduce="(opt) => opt.value"
                label="name"
                placeholder="select status"
                @input="setStatus()"
              />
            </b-form-group>
          </b-col>
          <b-col class="mt-1" md="12">
            <b-button
              variant="success"
              @click="getReport()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else>Show</span>
            </b-button>
          </b-col>
          <!-- <b-col class="mt-1" md="12" v-if="!isClasswiseEnrollment">
            <b-button
              variant="success"
              @click="getSheet()"
              :disabled="sheetLoading"
              block
            >
              <b-spinner v-if="sheetLoading" small type="grow" />
              <span v-else>Attendance Sheet</span>
            </b-button>
          </b-col> -->
          <b-col class="mt-1" md="12">
            <b-button
              variant="warning"
              @click="getReport(true)"
              :disabled="exporting"
              block
            >
              <b-spinner v-if="exporting" small type="grow" />
              <span v-else>Export</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility4"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Smart Attendance</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility4 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="pt-1 pb-1">
          <b-col md="12">
            <b-form-group
              label="Date"
              invalid-feedback="Date is required"
              ref="msg_date"
            >
              <flat-pickr
                ref="msg_date"
                :config="config"
                v-model="smartObj.dt"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Gr Numbers"
              invalid-feedback="Please enter gr separated by space"
              ref="grs"
            >
              <b-form-textarea
                ref="grs"
                placeholder="Enter gr numbers seperated by space"
                v-model="smartObj.gr"
                rows="4"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12" class="mt-1">
            <b-form-group
              label="Status"
              invalid-feedback="Status is required."
              ref="sm_status"
            >
              <v-select
                ref="sm_status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                v-model="smartObj.status"
                :options="smartOptions"
                :reduce="(opt) => opt.value"
                label="name"
                placeholder="select status"
              />
            </b-form-group>
          </b-col>
          <b-col class="mt-1" md="12">
            <b-button
              variant="success"
              @click="saveSmart()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else> Save </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Settings</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideSideBar()"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="pt-1 pb-1">
          <b-col
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <h4 class="mr-1">Barcode</h4>
            <b-form-checkbox
              v-model="settings.attendanceMode"
              switch
              value="barcode"
              unchecked-value=""
            />
          </b-col>
          <b-col
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <h4 class="mr-1">Notification on arrival</h4>
            <b-form-checkbox v-model="settings.notifyArrival" switch />
          </b-col>
          <!-- <b-col
              class="d-flex align-items-center justify-content-between mb-1"
              md="12"
            >
              <h4 class="mr-1">Notification on departure</h4>
              <b-form-checkbox v-model="settings.notifyDeparture" switch />
            </b-col> -->
          <b-col
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <h4 class="mr-1">Show dues</h4>
            <b-form-checkbox v-model="settings.showDues" switch />
          </b-col>
          <b-col
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <h4 class="mr-1">Show recent attendance</h4>
            <b-form-checkbox v-model="settings.showRecent" switch />
          </b-col>
          <b-col
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <h4 class="mr-1">Auto hide</h4>
            <b-form-checkbox v-model="settings.autoHide" switch />
          </b-col>
          <b-col v-if="settings.autoHide" md="12">
            <h4 class="mr-1">
              Hide After <span style="font-size: 14px">(seconds)</span>
            </h4>
            <b-form-input
              id="mc-first-name"
              type="number"
              placeholder=""
              ref="autosec"
              v-model="settings.hideAfterSeconds"
            />
          </b-col>
          <b-col class="mt-1" md="12">
            <b-button
              variant="success"
              @click="saveSettings()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else> Save </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-row v-if="showreport">
      <b-col>
        <div v-if="!isHappiness" class="d-flex justify-content-between">
          <b-button
            variant="outline-secondary"
            class="mr-50"
            @click="showreport = false"
          >
            <feather-icon class="" icon="ArrowLeftIcon" />
            Back
          </b-button>
        </div>
        <b-card class="mt-1">
          <b-row class="align-items-center">
            <b-col md="3" v-if="isHappiness">
              <b-form-group
                :label="$t('Date')"
                invalid-feedback="Date is required."
                ref="date"
              >
                <flat-pickr
                  ref="date"
                  :config="config3"
                  v-model="report.dtFrom"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                  @on-change="dtChange()"
                />
              </b-form-group>
            </b-col>
            <template v-else>
              <b-col md="2" v-if="showClasses">
                <b-form-group
                  :label="$t('Select ' + getLabel('Class'))"
                  :invalid-feedback="$t(getLabel('Class') + ' is required')"
                  ref="class"
                >
                  <v-select
                    ref="class"
                    multiple
                    :closeOnSelect="false"
                    v-model="classID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="classesOptions"
                    :clearable="false"
                    label="name"
                    :reduce="(val) => val.id"
                    @input="FillSections()"
                    :placeholder="$t('Select ' + getLabel('class'))"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2" v-if="showClasses">
                <b-form-group
                  :label="$t('Select ' + getLabel('Section'))"
                  :invalid-feedback="$t(getLabel('Section') + ' is required')"
                  ref="section"
                >
                  <v-select
                    multiple
                    :closeOnSelect="false"
                    v-model="secID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="admittedSections"
                    :reduce="(val) => val.id"
                    :clearable="false"
                    @input="checkSections()"
                    ref="section"
                    label="section"
                    :placeholder="$t('Select ' + getLabel('section'))"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4" v-if="isClasswiseEnrollment">
                <b-form-group
                  label="Select Subject"
                  invalid-feedback="Subject is required."
                  ref="sub"
                >
                  <v-select
                    v-model="selectedEnroll"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :filterBy="dropFilter"
                    :clearable="false"
                    :options="enrollFiltered"
                    label="name"
                    placeholder="Select subject and teacher"
                    :disabled="enLoading"
                  >
                    <template #option="option">
                      {{ option.clsName }} ({{ option.secName }}) -
                      {{ option.subName }} - {{ option.name }}
                    </template>
                    <template #selected-option="option">
                      {{ option.clsName }} ({{ option.secName }}) -
                      {{ option.subName }} - {{ option.name }}
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
              <template v-else>
                <b-col md="2">
                  <b-form-group
                    label="Select Subject"
                    invalid-feedback="Subject is required."
                    ref="sub"
                  >
                    <v-select
                      v-model="subID"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="subjects"
                      :reduce="(val) => val.id"
                      :clearable="false"
                      label="subject"
                      placeholder="Select subject"
                    />
                    <!-- @input="loadStaff()" -->
                  </b-form-group>
                </b-col>
                <b-col md="2" v-if="!isHappiness">
                  <b-form-group
                    label="Teacher"
                    invalid-feedback="Teacher is required."
                    ref="staff"
                  >
                    <v-select
                      v-model="tID"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="staffList"
                      :reduce="(opt) => opt.id"
                      label="name"
                      :clearable="false"
                      placeholder="Select teacher"
                    />
                  </b-form-group>
                </b-col>
              </template>
              <b-col md="2">
                <b-form-group
                  :label="$t('Date')"
                  invalid-feedback="Date is required."
                  ref="date"
                >
                  <flat-pickr
                    ref="date"
                    :config="config"
                    v-model="report.dtFrom"
                    class="form-control"
                    :placeholder="$t('Select Date')"
                  />
                </b-form-group>
              </b-col>
              <!-- <b-col md="2" v-if="isHappiness">
                <b-form-group
                  :label="$t('Age Category')"
                  invalid-feedback="Age category is required."
                >
                  <v-select
                    v-model="report.house"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="ageCategoryOptions"
                    :reduce="(opt) => opt.value"
                    label="text"
                    :clearable="false"
                    :placeholder="$t('Select age category')"
                  />
                </b-form-group>
              </b-col> -->
            </template>

            <b-button
              v-if="!isHappiness"
              :disabled="gridLoading"
              variant="primary"
              @click="loadgrid()"
            >
              Show
            </b-button>
            <b-button
              variant="success"
              class="ml-1"
              :disabled="saving || gridLoading || gridData.length == 0"
              @click="save()"
            >
              Save
            </b-button>
            <b-button
              v-if="!isHappiness"
              class="btn-icon ml-1"
              variant="outline-primary"
              v-b-tooltip.hover.top
              title="Smart Attendance"
              @click="showSmart()"
            >
              <feather-icon icon="CheckCircleIcon" />
            </b-button>
            <b-button
              v-if="!isHappiness"
              class="ml-1 btn-icon"
              variant="outline-primary"
              v-b-tooltip.hover.top
              title="Reports"
              @click="openReport()"
            >
              <feather-icon icon="BarChart2Icon" />
            </b-button>
            <b-button
              v-if="!isHappiness"
              class="ml-1 btn-icon"
              variant="outline-primary"
              v-b-tooltip.hover.top
              title="Messages"
              @click="openMessage()"
            >
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button
              class="ml-1 btn-icon"
              variant="outline-secondary"
              v-b-tooltip.hover.top
              :title="$t('Settings')"
              @click="showSettings()"
            >
              <!-- @click="openSett()" -->
              <feather-icon icon="SettingsIcon" />
            </b-button>
            <b-col
              md="auto"
              v-if="isHappiness"
              class="d-flex align-items-center flex-wrap my-25"
            >
              <div class="d-flex align-items-center flex-wrap" style="gap: 6px">
                <b-badge
                  variant="light-success"
                  class="d-inline-flex align-items-center py-50 px-75"
                >
                  <span class="bullet bullet-sm bullet-success mr-50" />
                  {{ $t("Present") }}
                </b-badge>
                <b-badge
                  variant="light-warning"
                  class="d-inline-flex align-items-center py-50 px-75"
                  style="
                    color: #b78103;
                    background-color: rgba(255, 193, 7, 0.15);
                  "
                >
                  <span
                    class="bullet bullet-sm mr-50"
                    style="background-color: #ffc107"
                  />
                  {{ $t("Late") }}
                </b-badge>
                <b-badge
                  variant="light-warning"
                  class="d-inline-flex align-items-center py-50 px-75"
                >
                  <span class="bullet bullet-sm bullet-warning mr-50" />
                  {{ $t("Very Late") }}
                </b-badge>
                <b-badge
                  variant="light-danger"
                  class="d-inline-flex align-items-center py-50 px-75"
                >
                  <span class="bullet bullet-sm bullet-danger mr-50" />
                  {{ $t("Absent") }}
                </b-badge>
                <b-badge
                  variant="light-info"
                  class="d-inline-flex align-items-center py-50 px-75"
                >
                  <span class="bullet bullet-sm bullet-info mr-50" />
                  {{ $t("Excused") }}
                </b-badge>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="isHappiness" class="mt-1">
            <b-col v-if="timetableLoading" md="12" class="text-center p-2">
              <b-spinner
                small
                variant="primary"
                class="mb-50"
                style="width: 3rem; height: 3rem"
              />
            </b-col>
            <b-col
              v-else-if="!assignedClasses.length"
              md="12"
              class="text-center p-2"
            >
              <feather-icon
                icon="BookOpenIcon"
                size="24"
                class="text-muted mb-50 mr-1"
              />
              <span>{{ $t("No classes scheduled for this day.") }}</span>
            </b-col>
            <b-col
              v-else
              v-for="(cls, idx) in assignedClasses"
              :key="cls.id"
              cols="12"
              lg="3"
              md="4"
              sm="6"
              class="mb-2"
            >
              <b-card
                :class="[
                  'shadow-sm',
                  { selected: selectedAssignedIndex === idx },
                  'mb-1',
                  'attendance-class-card',
                ]"
                @click="selectTimetableClass(cls, idx)"
                :body-class="'d-flex flex-column'"
                style="height: 100%; border-radius: 18px"
              >
                <div class="mb-50">
                  <span class="text-primary font-weight-bolder">
                    {{ cls.startTime }} – {{ cls.endTime }}
                  </span>
                </div>
                <div class="mb-50" style="font-weight: 700; font-size: 16px">
                  {{ cls.subject }}
                </div>
                <div
                  style="
                    color: #b1b1b1;
                    font-size: 13px;
                    font-weight: 400;
                    margin-bottom: 0.75rem;
                  "
                >
                  Group: {{ cls.name }} · Level: {{ cls.section }}
                </div>
                <div v-if="cls.obj" class="mt-auto attendance-class-card-tags">
                  <b-badge
                    v-if="cls.obj.ageCategory"
                    pill
                    variant="light-primary"
                  >
                    {{ cls.obj.ageCategory }}
                  </b-badge>
                  <b-badge
                    v-if="cls.obj.empowerLevel"
                    pill
                    variant="light-primary"
                  >
                    {{ cls.obj.empowerLevel }}
                  </b-badge>
                </div>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="mt-1" v-if="showGrid">
            <b-col lg="10" md="9">
              <b-form-group label="Search">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block"
                  placeholder="Search by name or gr"
                />
              </b-form-group>
            </b-col>
            <b-col lg="2" md="3">
              <b-form-group label="Sort By">
                <v-select
                  v-model="sortBy"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="sortOptions"
                  :reduce="(val) => val.value"
                  label="text"
                  @input="sortData()"
                  :clearable="false"
                  placeholder="Select"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-table
                class="mt-1"
                :busy="gridLoading"
                show-empty
                :items="filteredAtt"
                :fields="computedFields"
                responsive
                hover
                small
              >
                <template #table-busy>
                  <div class="d-flex justify-content-center mb-3 mt-3">
                    <b-spinner
                      style="width: 3rem; height: 3rem"
                      type="grow"
                      variant="primary"
                      label="Spinning"
                    ></b-spinner>
                  </div>
                </template>

                <template #head()="scope">
                  <div>
                    <span>{{ $t(getLabel(scope.label)) }}</span>
                  </div>
                </template>

                <template #cell(index)="data">
                  {{ gridData.indexOf(data.item) + 1 }}
                </template>

                <template #cell(cls)="data">
                  <b-badge variant="light-primary">
                    {{ data.item.cls }}
                  </b-badge>
                </template>
                <template #cell(timein)="data">
                  <b-badge v-if="data.item.obj.timeIn" variant="light-primary">
                    {{
                      new Intl.DateTimeFormat("en-US", {
                        hour: "numeric",
                        minute: "numeric",
                      }).format(new Date(data.item.obj.timeIn))
                    }}
                  </b-badge>
                </template>
                <template #cell(status)="data">
                  <div v-if="isHappiness" class="d-flex align-items-center">
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      :variant="
                        data.item.obj.status == 'P'
                          ? 'success'
                          : 'outline-success'
                      "
                      @click="changeAtt(data.index, 'P')"
                    >
                      P
                    </b-button>
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      :variant="
                        data.item.obj.status.toLowerCase() == 'late'
                          ? 'warning'
                          : 'outline-warning'
                      "
                      @click="changeAtt(data.index, 'Late')"
                    >
                      L
                    </b-button>
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      :variant="
                        data.item.obj.status.toLowerCase() == 'very late'
                          ? 'warning'
                          : 'outline-warning'
                      "
                      @click="changeAtt(data.index, 'Very Late')"
                    >
                      VL
                    </b-button>
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      :variant="
                        data.item.obj.status == 'A'
                          ? 'danger'
                          : 'outline-danger'
                      "
                      @click="changeAtt(data.index, 'A')"
                    >
                      A
                    </b-button>
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      :variant="
                        data.item.obj.status == 'L' ? 'info' : 'outline-info'
                      "
                      @click="changeAtt(data.index, 'L')"
                    >
                      E
                    </b-button>
                  </div>

                  <div v-else class="d-flex align-items-center">
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      :variant="
                        data.item.obj.status == 'P'
                          ? 'success'
                          : 'outline-success'
                      "
                      @click="changeAtt(data.index, 'P')"
                    >
                      P
                    </b-button>
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      :variant="
                        data.item.obj.status == 'A'
                          ? 'danger'
                          : 'outline-danger'
                      "
                      @click="changeAtt(data.index, 'A')"
                    >
                      A
                    </b-button>
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      :variant="
                        data.item.obj.status == 'L' ? 'info' : 'outline-info'
                      "
                      @click="changeAtt(data.index, 'L')"
                    >
                      L
                    </b-button>
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      :variant="
                        data.item.obj.status.toLowerCase() == 'late'
                          ? 'warning'
                          : 'outline-warning'
                      "
                      @click="changeAtt(data.index, 'Late')"
                    >
                      Late
                    </b-button>
                    <b-button
                      pill
                      size="sm"
                      style="margin-inline: 2px"
                      :variant="
                        data.item.obj.status == 'H' ? 'info' : 'outline-info'
                      "
                      @click="changeAtt(data.index, 'H')"
                    >
                      H
                    </b-button>
                  </div>
                </template>

                <template #cell(reason)="data">
                  <b-form-textarea
                    style="width: 200px"
                    rows="2"
                    size="sm"
                    v-model.trim="data.item.obj.meta_notes"
                    placeholder="Enter excused reason"
                    :disabled="data.item.obj.status != 'L'"
                  />
                </template>

                <template #cell(actions)="data">
                  <div>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
                      @click="Edit(data.item)"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <!-- attendance card -->
    <b-row align-h="center" v-else-if="dataLoading">
      <b-spinner
        class="m-5"
        style="width: 4rem; height: 4rem"
        type="grow"
        variant="primary"
        label="Spinning"
      ></b-spinner>
    </b-row>
    <div v-else>
      <b-row align-h="center">
        <b-col v-if="studentLoading" md="4">
          <b-card class="text-center p-1" style="position: relative">
            <b-spinner
              class="m-5"
              style="width: 4rem; height: 4rem"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </b-card>
        </b-col>
        <b-col lg="4" md="5" v-else>
          <b-card class="text-center p-1" style="position: relative">
            <!-- <feather-icon
              class="cursor-pointer"
              style="position: absolute; right: 15px; top: 15px"
              icon="SettingsIcon"
              size="22"
              v-b-tooltip.hover.right
              title="Settings"
              @click="showSettings()"
            /> -->
            <b-img
              v-if="
                currentStd.std.picture == '' || currentStd.std.picture == null
              "
              class="round mb-1"
              src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
              style="
                width: 100px;
                height: 100px;
                object-fit: cover;
                border-radius: 50%;
              "
              :class="{ 'set-picSize': picObj && picObj.valueBool }"
            />
            <b-img
              v-else
              class="round mb-1"
              :src="currentStd.std.picture"
              style="
                width: 100px;
                height: 100px;
                object-fit: cover;
                border-radius: 50%;
              "
              :class="{ 'set-picSize': picObj && picObj.valueBool }"
            />
            <h3 v-if="currentStd.std.name" class="mb-1">
              {{ currentStd.std.name }}
            </h3>
            <h3 v-else class="mb-1">-</h3>
            <h4 v-if="currentStd.std.cls" style="margin-bottom: 0.5rem">
              {{ currentStd.std.cls }}
            </h4>
            <h4 v-else style="margin-bottom: 0.5rem">-</h4>
            <h4 style="font-weight: 400; margin-bottom: 0.5rem">
              GR #
              <span v-if="currentStd.std.grNo">{{ currentStd.std.grNo }}</span>
              <span v-else>-</span>
            </h4>
            <h4
              v-if="settings.showDues"
              style="font-weight: 400; margin-bottom: 0.5rem"
            >
              Dues: <span v-if="currentStd.dues">{{ currentStd.dues }}</span>
              <span v-else>-</span>
            </h4>
            <h1 v-if="currentStd.time" class="mt-1">
              {{
                new Intl.DateTimeFormat("en-US", {
                  hour: "numeric",
                  minute: "numeric",
                }).format(new Date(currentStd.time))
              }}
            </h1>

            <!-- <h4 class="text-danger font-weight-bolder">dues</h4> -->
            <b-row align-h="center">
              <b-form-input
                class="mt-1"
                style="width: 80%"
                id="mc-first-name"
                placeholder="Scan here"
                ref="name"
                autofocus
                v-model="studentID"
                @keyup.enter="GetStudent()"
              />
            </b-row>
          </b-card>
        </b-col>
        <b-col lg="1" md="2" class="d-flex flex-wrap d-md-block">
          <b-card
            class="mb-1 mr-1 mr-md-0 rounded-circle"
            style="width: 45px; height: 45px"
            v-b-tooltip.hover.right="'Settings'"
            body-class="d-flex align-items-center justify-content-center p-50"
          >
            <feather-icon
              class="cursor-pointer"
              icon="SettingsIcon"
              size="22"
              @click="showSettings()"
            />
          </b-card>
          <b-card
            v-if="syncObj && syncObj.valueBool"
            class="mb-1 mr-1 mr-md-0 rounded-circle"
            style="width: 45px; height: 45px"
            v-b-tooltip.hover.right="'Sync Attendance'"
            body-class="d-flex align-items-center justify-content-center p-50"
          >
            <b-spinner
              v-if="syncing"
              class=""
              variant="primary"
              label="Spinning"
              style="width: 22px; height: 22px"
            ></b-spinner>
            <feather-icon
              v-else
              class="cursor-pointer"
              icon="RefreshCcwIcon"
              size="22"
              :badge="syncData.length + staffData.length"
              @click="syncAtt()"
            />
          </b-card>
          <!-- <b-card
              v-if="syncObj && syncObj.valueBool"
              class="mb-1 mr-1 mr-md-0 rounded-circle"
              style="width: 45px; height: 45px"
              v-b-tooltip.hover.right="'Student In'"
              body-class="d-flex align-items-center justify-content-center p-50"
            >
              <feather-icon
                class="cursor-pointer"
                icon="UserPlusIcon"
                size="22"
                :badge="stdInCount"
              />
            </b-card> -->
          <b-card
            class="mb-1 mr-1 mr-md-0 rounded-circle"
            style="width: 45px; height: 45px"
            v-b-tooltip.hover.right="'Smart Attendance'"
            body-class="d-flex align-items-center justify-content-center p-50"
          >
            <feather-icon
              class="cursor-pointer"
              icon="CheckCircleIcon"
              size="22"
              @click="showSmart()"
            />
          </b-card>
          <b-card
            class="mb-1 mr-1 mr-md-0 rounded-circle"
            style="width: 45px; height: 45px"
            v-b-tooltip.hover.right="'Reports'"
            body-class="d-flex align-items-center justify-content-center p-50"
          >
            <feather-icon
              class="cursor-pointer"
              icon="BarChart2Icon"
              size="22"
              @click="openReport()"
            />
          </b-card>
          <b-card
            class="mb-1 mr-1 mr-md-0 rounded-circle"
            style="width: 45px; height: 45px"
            v-b-tooltip.hover.right="'Messages'"
            body-class="d-flex align-items-center justify-content-center p-50"
          >
            <feather-icon
              class="cursor-pointer"
              icon="MailIcon"
              size="22"
              @click="openMessage()"
            />
          </b-card>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col lg="4" md="5">
          <b-button variant="primary" block @click="openDetails()">
            Show Details
          </b-button>
        </b-col>
        <b-col lg="1" md="2"></b-col>
      </b-row>
      <b-row v-if="this.settings.showRecent && this.filteredItems.length > 0">
        <b-col md="12">
          <h3>Recent Attendance</h3>
        </b-col>
        <b-col lg="3" md="4" v-for="card in filteredItems" :key="card">
          <b-card
            class="text-center shadow-sm"
            style="border-radius: 12px; overflow: hidden"
            :class="{
              'set-border': card.dues > 0,
            }"
          >
            <b-avatar
              v-if="card.std.picture == '' || card.std.picture == null"
              size="80"
              src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
              class="mb-1 mt-1 shadow-sm"
              :class="{ 'border-danger': card.dues > 0 }"
            />
            <b-avatar
              v-else
              size="80"
              :src="card.std.picture"
              class="mb-1 mt-1 shadow-sm"
              :class="{ 'border-danger': card.dues > 0 }"
            />

            <h4 class="font-weight-bolder mb-50">{{ card.std.name }}</h4>

            <h6 class="text-muted mb-1">
              {{ card.std.cls }}
              <span class="mx-50">•</span>
              GR# {{ card.std.grNo }}
            </h6>

            <div
              class="d-flex justify-content-center flex-wrap align-items-center mb-1"
              style="gap: 5px"
            >
              <b-badge variant="light-primary" pill>
                <feather-icon icon="ClockIcon" size="12" class="mr-25" />
                {{
                  new Intl.DateTimeFormat("en-US", {
                    hour: "numeric",
                    minute: "numeric",
                  }).format(new Date(card.time))
                }}
              </b-badge>
              <b-badge
                v-if="card.std.status"
                :variant="
                  card.std.status.toLowerCase() == 'absent'
                    ? 'light-danger'
                    : 'light-success'
                "
                pill
                class="text-uppercase"
                style="letter-spacing: 0.5px"
              >
                {{ card.std.status }}
              </b-badge>
              <b-badge
                v-if="settings.showDues && card.dues > 0"
                variant="light-danger"
                pill
              >
                Dues: {{ card.dues }}
              </b-badge>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <!-- add attendance modal here -->
    <b-modal
      v-model="showReportModal"
      size="xl"
      scrollable
      no-close-on-backdrop
      dialog-class="attendance-stats-dialog"
      body-class="p-2 attendance-stats-modal-body"
    >
      <template #modal-header="{ close }">
        <div class="d-flex justify-content-between align-items-center w-100">
          <div class="d-flex align-items-center">
            <div class="avatar bg-light-primary mr-1 p-50 rounded">
              <feather-icon
                icon="BarChart2Icon"
                size="20"
                class="text-primary"
              />
            </div>
            <div>
              <h4 class="mb-25 font-weight-bolder">
                {{ $t("Subject-wise Attendance Summary") }}
              </h4>
              <p class="text-muted mb-0 small">
                {{
                  $t(
                    "Filter and view student attendance statistics across subjects"
                  )
                }}
              </p>
            </div>
          </div>
          <b-button
            variant="flat-secondary"
            size="sm"
            class="btn-icon rounded-circle"
            @click="close()"
          >
            <feather-icon icon="XIcon" size="18" />
          </b-button>
        </div>
      </template>

      <!-- Filters Card -->
      <b-card no-body class="border mb-2 shadow-none bg-light">
        <div class="p-1">
          <b-row>
            <b-col md="3" sm="6">
              <b-form-group :label="$t('Date From') + ' *'" class="mb-1">
                <flat-pickr
                  v-model="otherReportObj.dateFrom"
                  :config="config"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>
            <b-col md="3" sm="6">
              <b-form-group :label="$t('Date Till') + ' *'" class="mb-1">
                <flat-pickr
                  v-model="otherReportObj.dateTill"
                  :config="config"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>
            <b-col md="3" sm="6">
              <b-form-group :label="$t(getLabel('Class'))" class="mb-1">
                <v-select
                  multiple
                  :closeOnSelect="false"
                  v-model="otherReportObj.classIDs"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="modalClassOptions"
                  :reduce="(val) => val.id"
                  label="name"
                  @input="onModalClassChange()"
                  :placeholder="$t('Select ' + getLabel('class'))"
                />
              </b-form-group>
            </b-col>
            <b-col md="3" sm="6">
              <b-form-group :label="$t(getLabel('Section'))" class="mb-1">
                <v-select
                  multiple
                  :closeOnSelect="false"
                  v-model="otherReportObj.sectionIDs"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="modalSectionOptions"
                  :reduce="(val) => val.id"
                  label="section"
                  :placeholder="$t('Select ' + getLabel('section'))"
                />
              </b-form-group>
            </b-col>
            <b-col md="4" sm="6">
              <b-form-group :label="$t('Subjects')" class="mb-1 mb-md-0">
                <v-select
                  multiple
                  :closeOnSelect="false"
                  v-model="otherReportObj.subjectIDs"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="modalSubjectOptions"
                  :reduce="(val) => val.id"
                  label="subject"
                  :placeholder="$t('Select subjects')"
                />
              </b-form-group>
            </b-col>
            <b-col md="4" sm="6">
              <b-form-group :label="$t('Student')" class="mb-1 mb-md-0">
                <v-select
                  v-model="otherReportObj.studentID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="searchedStudentOptions"
                  :reduce="(val) => val.id"
                  label="label"
                  :filterable="false"
                  :loading="studentSearchLoading"
                  @search="onStatsStudentSearch"
                  :placeholder="$t('Search and select student...')"
                >
                  <template #option="item">
                    <div class="d-flex flex-column py-25">
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <span class="font-weight-bold">{{ item.name }}</span>
                        <!-- <small
                          v-if="item.grNo"
                          class="badge badge-light-primary font-small-1"
                          >GR# {{ item.grNo }}</small
                        > -->
                      </div>
                      <small class="text-muted">
                        <span v-if="item.className">{{ item.className }}</span>
                        <span v-if="item.sectionName">
                          • {{ item.sectionName }}</span
                        >
                        <span v-if="item.father_name">
                          • Father: {{ item.father_name }}</span
                        >
                      </small>
                    </div>
                  </template>
                  <template #selected-option="item">
                    <div class="d-flex align-items-center">
                      <span>{{ item.name }}</span>
                      <!-- <small v-if="item.grNo" class="text-muted ml-50"
                        >(GR# {{ item.grNo }})</small
                      > -->
                      <small v-if="item.className" class="text-muted ml-50"
                        >- {{ item.className }}</small
                      >
                    </div>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col
              md="4"
              sm="12"
              class="d-flex align-items-end justify-content-end"
            >
              <b-button
                variant="outline-secondary"
                class="mr-1"
                @click="resetStatsFilter()"
                :disabled="statsLoading"
              >
                <feather-icon icon="RotateCcwIcon" class="mr-50" />
                {{ $t("Reset") }}
              </b-button>
              <b-button
                variant="primary"
                @click="loadAttendanceStats()"
                :disabled="statsLoading"
              >
                <b-spinner
                  v-if="statsLoading"
                  small
                  type="grow"
                  class="mr-50"
                />
                <feather-icon v-else icon="FilterIcon" class="mr-50" />
                {{ $t("Apply Filter") }}
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-card>

      <!-- Status Legend & Search Bar -->
      <div v-if="otherReportItems && otherReportItems.length" class="mb-1">
        <b-row class="align-items-center">
          <b-col md="6" class="mb-1 mb-md-0">
            <b-form-input
              v-model="statsSearchQuery"
              :placeholder="
                $t('Search student by name, father, GR#, or class...')
              "
              class="stats-search-input"
            />
          </b-col>
          <b-col md="6">
            <div
              class="d-flex align-items-center justify-content-md-end flex-wrap"
              style="gap: 6px"
            >
              <b-badge
                variant="light-success"
                class="d-inline-flex align-items-center py-50 px-75"
              >
                <span class="bullet bullet-sm bullet-success mr-50" />
                {{ $t("Present") }}
              </b-badge>
              <b-badge
                variant="light-warning"
                class="d-inline-flex align-items-center py-50 px-75"
                style="
                  color: #b78103;
                  background-color: rgba(255, 193, 7, 0.15);
                "
              >
                <span
                  class="bullet bullet-sm mr-50"
                  style="background-color: #ffc107"
                />
                {{ $t("Late") }}
              </b-badge>
              <b-badge
                variant="light-warning"
                class="d-inline-flex align-items-center py-50 px-75"
              >
                <span class="bullet bullet-sm bullet-warning mr-50" />
                {{ $t("Very Late") }}
              </b-badge>
              <b-badge
                variant="light-danger"
                class="d-inline-flex align-items-center py-50 px-75"
              >
                <span class="bullet bullet-sm bullet-danger mr-50" />
                {{ $t("Absent") }}
              </b-badge>
              <b-badge
                variant="light-info"
                class="d-inline-flex align-items-center py-50 px-75"
              >
                <span class="bullet bullet-sm bullet-info mr-50" />
                {{ $t("Excused") }}
              </b-badge>
            </div>
          </b-col>
        </b-row>
      </div>

      <!-- Loading State -->
      <div v-if="statsLoading" class="text-center my-4 py-3">
        <b-spinner
          variant="primary"
          style="width: 3.5rem; height: 3.5rem"
          type="grow"
        />
        <h5 class="text-muted mt-2 font-weight-normal">
          {{ $t("Loading attendance statistics...") }}
        </h5>
      </div>

      <!-- Initial / Empty State -->
      <div
        v-else-if="
          !statsApplied && (!otherReportItems || !otherReportItems.length)
        "
        class="text-center my-4 py-3 text-muted"
      >
        <div
          class="avatar bg-light-primary p-1 mb-1 rounded-circle"
          style="
            width: 64px;
            height: 64px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
          "
        >
          <feather-icon icon="FilterIcon" size="32" class="text-primary" />
        </div>
        <h5 class="font-weight-bolder text-dark mb-50">
          {{ $t("No Filters Applied Yet") }}
        </h5>
        <p class="text-muted small mb-0">
          {{
            $t(
              "Select the required date range and filters above, then click Apply Filter to generate the summary."
            )
          }}
        </p>
      </div>

      <!-- No records after filter -->
      <div
        v-else-if="
          statsApplied &&
          (!filteredStatsStudents || !filteredStatsStudents.length)
        "
        class="text-center my-4 py-3 text-muted"
      >
        <div
          class="avatar bg-light-secondary p-1 mb-1 rounded-circle"
          style="
            width: 64px;
            height: 64px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
          "
        >
          <feather-icon icon="InboxIcon" size="32" class="text-secondary" />
        </div>
        <h5 class="font-weight-bolder text-dark mb-50">
          {{ $t("No Student Records Found") }}
        </h5>
        <p class="text-muted small mb-0">
          {{
            $t(
              "Try adjusting your date range or class/section/subject filters."
            )
          }}
        </p>
      </div>

      <!-- Students List View -->
      <div v-else class="attendance-stats-list">
        <b-card
          v-for="std in filteredStatsStudents"
          :key="std.sID || std.grNo"
          no-body
          class="border mb-1 shadow-sm student-stats-card"
        >
          <div
            class="p-1 border-bottom bg-white d-flex flex-wrap justify-content-between align-items-center"
          >
            <div class="d-flex align-items-center">
              <b-avatar
                :src="std.picture"
                size="46"
                variant="light-primary"
                class="mr-1 shadow-xs"
              >
                <feather-icon v-if="!std.picture" icon="UserIcon" size="20" />
              </b-avatar>
              <div>
                <div
                  class="d-flex align-items-center flex-wrap"
                  style="gap: 6px"
                >
                  <h5 class="mb-0 font-weight-bolder text-dark">
                    {{ std.name || "-" }}
                  </h5>
                  <!-- <b-badge
                    variant="light-primary"
                    pill
                    class="px-75 py-25 font-small-2"
                  >
                    GR# {{ std.grNo || "-" }}
                  </b-badge> -->
                  <b-badge
                    variant="light-info"
                    pill
                    class="px-75 py-25 font-small-2"
                  >
                    {{ std.className || "-" }}
                    <span v-if="std.sectionName">• {{ std.sectionName }}</span>
                  </b-badge>
                </div>
                <small v-if="std.father_name" class="text-muted d-block mt-25">
                  {{ $t("Father") }}: {{ std.father_name }}
                </small>
              </div>
            </div>

            <!-- <div
              class="d-flex align-items-center mt-50 mt-sm-0"
              style="gap: 10px"
            >
              <div class="text-right">
                <small class="text-muted d-block font-small-2">{{
                  $t("Overall Attendance")
                }}</small>
                <b-badge
                  :variant="
                    getPercentageBadgeVariant(getStudentOverallPercentage(std))
                  "
                  pill
                  class="font-small-3 font-weight-bolder px-1 py-25"
                >
                  {{ getStudentOverallPercentage(std) }}%
                </b-badge>
              </div>
            </div> -->
          </div>

          <!-- Subject Breakdown Table -->
          <div class="table-responsive mb-50">
            <table
              class="table table-sm table-hover mb-0 text-center font-small-3"
            >
              <thead class="thead-light">
                <tr>
                  <th class="text-left pl-1" style="min-width: 140px">
                    {{ $t("Subject") }}
                  </th>
                  <th style="min-width: 60px">
                    <span class="text-success font-weight-bolder">P</span>
                  </th>
                  <th style="min-width: 60px">
                    <span class="text-warning font-weight-bolder">{{
                      $t("Late")
                    }}</span>
                  </th>
                  <th style="min-width: 65px">
                    <span style="color: #ff9f43" class="font-weight-bolder">{{
                      $t("Very Late")
                    }}</span>
                  </th>
                  <th style="min-width: 60px">
                    <span class="text-danger font-weight-bolder">A</span>
                  </th>
                  <th style="min-width: 60px">
                    <span class="text-info font-weight-bolder">E</span>
                  </th>
                  <!-- <th style="min-width: 60px">
                    <span class="text-secondary font-weight-bolder">H</span>
                  </th>  -->
                  <th style="min-width: 70px">{{ $t("Total") }}</th>
                  <th style="min-width: 130px">{{ $t("Percentage") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="sub in std.subjects"
                  :key="sub.subID || sub.subject"
                  @click="showAttDetails(std, sub)"
                >
                  <td
                    class="text-left pl-1 font-weight-bold text-dark align-middle"
                  >
                    {{ sub.subject || "-" }}
                  </td>
                  <td class="align-middle">
                    <b-badge
                      variant="light-success"
                      pill
                      class="px-75 py-25 font-small-2"
                    >
                      {{ sub.p || sub.P || 0 }}
                    </b-badge>
                  </td>
                  <td class="align-middle">
                    <b-badge
                      variant="light-warning"
                      pill
                      class="px-75 py-25 font-small-2"
                      style="
                        color: #b78103;
                        background-color: rgba(255, 193, 7, 0.15);
                      "
                    >
                      {{ sub.late || sub.Late || 0 }}
                    </b-badge>
                  </td>
                  <td class="align-middle">
                    <b-badge
                      variant="light-warning"
                      pill
                      class="px-75 py-25 font-small-2"
                    >
                      {{ sub.veryLate || sub.verylate || sub.VeryLate || 0 }}
                    </b-badge>
                  </td>
                  <td class="align-middle">
                    <b-badge
                      variant="light-danger"
                      pill
                      class="px-75 py-25 font-small-2"
                    >
                      {{ sub.a || sub.A || 0 }}
                    </b-badge>
                  </td>
                  <td class="align-middle">
                    <b-badge
                      variant="light-info"
                      pill
                      class="px-75 py-25 font-small-2"
                    >
                      {{ sub.l || sub.L || 0 }}
                    </b-badge>
                  </td>
                  <!-- <td class="align-middle text-muted">
                    {{ sub.h || sub.H || 0 }}
                  </td> -->
                  <td class="align-middle font-weight-bolder text-dark">
                    {{ sub.total || sub.Total || 0 }}
                  </td>
                  <td class="align-middle font-weight-bolder text-dark">
                    {{ sub.percentage || sub.Percentage || 0 }}%
                  </td>
                </tr>
                <tr
                  v-if="std.subjects && std.subjects.length"
                  class="font-weight-bolder bg-light"
                  @click="showAttDetails(std, null)"
                >
                  <td
                    class="text-left pl-1 font-weight-bolder text-dark align-middle"
                  >
                    {{ $t("Total") }}
                  </td>
                  <td class="align-middle">
                    <b-badge
                      variant="light-success"
                      pill
                      class="px-75 py-25 font-small-2"
                    >
                      {{ std.p || std.P || 0 }}
                    </b-badge>
                  </td>
                  <td class="align-middle">
                    <b-badge
                      variant="light-warning"
                      pill
                      class="px-75 py-25 font-small-2"
                      style="
                        color: #b78103;
                        background-color: rgba(255, 193, 7, 0.15);
                      "
                    >
                      {{ std.late || std.Late || 0 }}
                    </b-badge>
                  </td>
                  <td class="align-middle">
                    <b-badge
                      variant="light-warning"
                      pill
                      class="px-75 py-25 font-small-2"
                    >
                      {{ std.veryLate || std.verylate || std.VeryLate || 0 }}
                    </b-badge>
                  </td>
                  <td class="align-middle">
                    <b-badge
                      variant="light-danger"
                      pill
                      class="px-75 py-25 font-small-2"
                    >
                      {{ std.a || std.A || 0 }}
                    </b-badge>
                  </td>
                  <td class="align-middle">
                    <b-badge
                      variant="light-info"
                      pill
                      class="px-75 py-25 font-small-2"
                    >
                      {{ std.l || std.L || 0 }}
                    </b-badge>
                  </td>
                  <td class="align-middle font-weight-bolder text-dark">
                    {{ std.total || std.Total || 0 }}
                  </td>
                  <td class="align-middle font-weight-bolder text-dark">
                    {{ std.percentage || std.Percentage || 0 }}%
                  </td>
                </tr>
                <tr v-if="!std.subjects || !std.subjects.length">
                  <td
                    colspan="9"
                    class="text-center text-muted py-1 font-small-2"
                  >
                    {{
                      $t("No subject attendance records found for this student")
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card>
      </div>

      <template #modal-footer="{ close }">
        <div class="d-flex justify-content-between align-items-center w-100">
          <span class="text-muted font-small-2">
            <template
              v-if="filteredStatsStudents && filteredStatsStudents.length"
            >
              {{ $t("Showing") }}
              <strong>{{ filteredStatsStudents.length }}</strong>
              {{ $t("student(s)") }}
            </template>
          </span>
          <b-button variant="secondary" size="sm" @click="close()">
            {{ $t("Close") }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="modal-att-details"
      :title="$t('Attendance Details')"
      centered
      size="lg"
      footer-class="justify-content-between"
      body-class="p-1"
    >
      <div v-if="studentDetailsLoading" class="text-center py-3">
        <b-spinner variant="primary" label="Loading..." />
        <p class="text-muted mt-50 mb-0 font-small-3">
          {{ $t("Loading attendance details...") }}
        </p>
      </div>

      <div
        v-else-if="studentDetailsList && studentDetailsList.length"
        class="attendance-details-container"
      >
        <div
          v-for="stdItem in studentDetailsList"
          :key="stdItem.sID"
          class="mb-1"
        >
          <!-- Student Info Header -->
          <div
            class="p-1 rounded bg-light border-bottom mb-1 d-flex flex-wrap justify-content-between align-items-center"
          >
            <div class="d-flex align-items-center">
              <b-avatar
                :src="stdItem.picture"
                size="46"
                variant="light-primary"
                class="mr-1 shadow-xs"
              >
                <feather-icon
                  v-if="!stdItem.picture"
                  icon="UserIcon"
                  size="20"
                />
              </b-avatar>
              <div>
                <div
                  class="d-flex align-items-center flex-wrap"
                  style="gap: 6px"
                >
                  <h5 class="mb-0 font-weight-bolder text-dark">
                    {{ stdItem.name || "-" }}
                  </h5>
                  <b-badge
                    v-if="stdItem.grNo"
                    variant="light-primary"
                    pill
                    class="px-75 py-25 font-small-2"
                  >
                    GR# {{ stdItem.grNo }}
                  </b-badge>
                  <b-badge
                    v-if="stdItem.className || stdItem.sectionName"
                    variant="light-info"
                    pill
                    class="px-75 py-25 font-small-2"
                  >
                    {{ stdItem.className || "-" }}
                    <span v-if="stdItem.sectionName"
                      >• {{ stdItem.sectionName }}</span
                    >
                  </b-badge>
                </div>
                <small
                  v-if="stdItem.father_name"
                  class="text-muted d-block mt-25"
                >
                  {{ $t("Father") }}: {{ stdItem.father_name }}
                </small>
              </div>
            </div>
          </div>

          <!-- Attendance Records Table -->
          <div
            class="table-responsive"
            style="max-height: 420px; overflow-y: auto"
          >
            <table
              class="table table-sm table-hover mb-0 text-center font-small-3"
            >
              <thead
                class="thead-light"
                style="position: sticky; top: 0; z-index: 1"
              >
                <tr>
                  <th style="width: 50px">#</th>
                  <th class="text-left pl-1" style="min-width: 130px">
                    {{ $t("Date") }}
                  </th>
                  <th class="text-left pl-1" style="min-width: 150px">
                    {{ $t("Subject") }}
                  </th>
                  <th style="min-width: 90px">
                    {{ $t("Status") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(rec, rIdx) in stdItem.attendance"
                  :key="rec.id || rIdx"
                >
                  <td class="align-middle text-muted">{{ rIdx + 1 }}</td>
                  <td
                    class="align-middle text-left pl-1 font-weight-bold text-dark"
                  >
                    {{
                      rec.date
                        ? new Date(rec.date).toLocaleDateString("en-UK", {
                            year: "numeric",
                            day: "numeric",
                            month: "short",
                          })
                        : "-"
                    }}
                  </td>
                  <td class="align-middle text-left pl-1">
                    {{ rec.subject || rec.subjectName || "-" }}
                  </td>
                  <td class="align-middle">
                    <b-badge
                      :variant="getAttStatusVariant(rec.status)"
                      :style="getAttStatusStyle(rec.status)"
                      pill
                      class="px-75 py-25 font-small-2 font-weight-bolder"
                    >
                      {{ $t(formatAttStatus(rec.status)) }}
                    </b-badge>
                  </td>
                </tr>
                <tr v-if="!stdItem.attendance || !stdItem.attendance.length">
                  <td
                    colspan="4"
                    class="text-center text-muted py-2 font-small-2"
                  >
                    {{ $t("No attendance records found") }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-else class="text-center py-3 text-muted">
        <feather-icon icon="InboxIcon" size="32" class="mb-50 text-muted" />
        <p class="mb-0 font-small-3">
          {{ $t("No attendance records found") }}
        </p>
      </div>

      <template #modal-footer="{ close }">
        <div class="d-flex justify-content-between align-items-center w-100">
          <span class="text-muted font-small-2">
            <template v-if="studentDetailsList && studentDetailsList.length">
              {{ $t("Total Records") }}:
              <strong>
                {{
                  studentDetailsList.reduce(
                    (acc, s) =>
                      acc + ((s.attendance && s.attendance.length) || 0),
                    0
                  )
                }}
              </strong>
            </template>
          </span>
          <b-button variant="secondary" size="sm" @click="close()">
            {{ $t("Close") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BAvatar,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BModal,
  BFormGroup,
  BForm,
  BMediaAside,
  BSpinner,
  BCardTitle,
  BCardText,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroup,
  BFormTextarea,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

export default {
  components: {
    BFormTextarea,
    BMedia,
    BMediaAside,
    BCard,
    BRow,
    BImg,
    BAvatar,
    BBadge,
    BTable,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BModal,
    BForm,
    BPagination,
    BSpinner,
    BDropdown,
    BDropdownItem,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    if (!this.$store.state.rights[this.$route.name]) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      if (this.isHappiness) {
        this.openDetails();
        this.dtChange();
      }
      this.classesOptions = [
        { name: "All " + this.getLabel("Classes"), id: 0 },
      ];
      this.admittedSections = [
        { section: "All " + this.getLabel("Sections"), id: 0 },
      ];
      this.repSecOptions = [
        { section: "All " + this.getLabel("Sections"), id: 0 },
      ];
      this.msgSecOptions = [
        { section: "All " + this.getLabel("Sections"), id: 0 },
      ];

      this.LoadClasses();
      this.LoadSettings();
      this.loadSessions();
      this.LoadSubjects();
      this.loadStaff();
      this.loadOther();
    }

    // this.LoadClasses();
    // this.LoadSettings();
    // this.loadSessions();
    // this.LoadSubjects();
    // this.loadStaff();
    // this.loadOther();
  },
  computed: {
    filteredItems: function () {
      return this.items.slice(0, 12);
    },
    filteredAtt() {
      return this.gridData.filter((pro) => {
        return (
          pro.name.toLowerCase().match(this.searchQuery.toLowerCase()) ||
          pro.grNo.toLowerCase().match(this.searchQuery.toLowerCase())
        );
      });
    },
    computedFields() {
      if (this.isHappiness) return this.happinessFields;
      else return this.fields;
    },
    enrollFiltered() {
      // all classes and all sections
      let allCls = this.classID.length == 0 || this.classID.at(-1) == 0;
      if (allCls) return this.enrollOptions;

      let secSelected = this.secID.length > 0 && this.secID.at(-1) != 0;
      return this.enrollOptions.filter((el) => {
        if (secSelected)
          return (
            this.secID.includes(el.us.section) &&
            this.classID.includes(el.us.cID)
          );
        else return this.classID.includes(el.us.cID);
      });
    },
    isHappiness() {
      return this.reportDomain == "myskoolhappinessfoundation";
    },
    modalClassOptions() {
      return (this.classes || []).map((el) => el.cls).filter(Boolean);
    },
    modalSectionOptions() {
      if (
        !this.classes ||
        !this.classes.length ||
        !this.otherReportObj.classIDs ||
        !this.otherReportObj.classIDs.length
      ) {
        return [];
      }
      const selectedClassIds = this.otherReportObj.classIDs;
      let secList = [];
      this.classes.forEach((elem) => {
        if (elem.cls && selectedClassIds.includes(elem.cls.id)) {
          if (elem.sections && elem.sections.length) {
            elem.sections.forEach((s) => {
              if (!secList.some((existing) => existing.id === s.id)) {
                secList.push(s);
              }
            });
          }
        }
      });
      return secList;
    },
    modalSubjectOptions() {
      return this.subjects || [];
    },
    filteredStatsStudents() {
      if (!this.otherReportItems || !this.otherReportItems.length) return [];
      if (!this.statsSearchQuery) return this.otherReportItems;
      const q = this.statsSearchQuery.toLowerCase().trim();
      return this.otherReportItems.filter((std) => {
        const name = String(std.name || "").toLowerCase();
        const father = String(std.father_name || "").toLowerCase();
        const gr = String(std.grNo || "").toLowerCase();
        const cls = String(std.className || "").toLowerCase();
        const sec = String(std.sectionName || "").toLowerCase();
        return (
          name.includes(q) ||
          father.includes(q) ||
          gr.includes(q) ||
          cls.includes(q) ||
          sec.includes(q)
        );
      });
    },
  },
  data() {
    return {
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      rights: {},
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      config3: {
        altFormat: "j M, Y l",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      repDate: "",
      config2: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "range",
      },
      request: false,
      sheetLoading: false,
      exporting: false,
      attendance: {
        picture: null,
        obj: {
          status: null,
        },
      },
      dataLoading: false,
      studentLoading: false,
      visibility: false,
      visibility2: false,
      visibility3: false,
      visibility4: false,
      searchQuery: "",
      sortOptions: [
        { text: "Name", value: "name" },
        { text: "GR#", value: "gr" },
      ],
      sortBy: this.$store.state.attSort,
      ageCategoryOptions: [
        { text: "All", value: "" },
        { text: "Junior", value: "junior" },
        { text: "Senior", value: "senior" },
      ],
      report: {
        type: "",
        dtFrom: new Date().toJSON().split("T")[0],
        // dtTo: null,
        clsIDs: [],
        secIDs: [],
        house: "",
      },
      editAtt: false,
      timePicker: null,
      datepickr: null,
      showreport: false,
      rangeDate: null,
      types: [
        { name: "Student", value: "student" },
        { name: "Staff", value: "staff" },
      ],
      statusOptions: [
        { name: "All", value: "" },
        { name: "Present", value: "P" },
        { name: "Absent", value: "A" },
        { name: "Leave", value: "L" },
        { name: "Late", value: "Late" },
      ],
      smartOptions: [
        { name: "Absent", value: "A" },
        { name: "Leave", value: "L" },
        { name: "Late", value: "Late" },
      ],
      showClasses: false,
      classes: [],
      classesOptions: [],
      admittedSections: [],
      classID: [0],
      secID: [0],
      subID: 0,
      tID: 0,
      gridData: [],
      showGrid: false,
      gridLoading: false,
      fields: [
        { label: "S.no", key: "index" },
        { label: "gr no", key: "grNo" },
        { label: "name", key: "name" },
        { label: "Father name", key: "father_name" },
        { label: "class", key: "cls" },
        { label: "status", key: "status" },
        // { key: "actions", label: "actions" },
      ],
      happinessFields: [
        { label: "S.no", key: "index" },
        { label: "nickname", key: "surname" },
        { label: "name", key: "name" },
        { label: "class", key: "cls" },
        { label: "status", key: "status" },
        { label: "reason", key: "reason" },
      ],
      items: [],
      selected: null,
      myObj: {
        picture: null,
        cls: null,
        grNo: null,
        name: null,
      },
      currentStd: {
        std: {
          picture: null,
          cls: null,
          grNo: null,
          name: null,
        },
      },
      settings: {
        id: 0,
        campusID: this.$store.state.userData.cId,
        notifyArrival: false,
        notifyDeparture: false,
        showDues: false,
        showRecent: false,
        autoHide: false,
        hideAfterSeconds: 5,
        attendanceMode: "",
      },
      msgObj: {
        dt: "",
        clsIDs: [0],
        secIDs: [0],
        status: "",
      },
      msgSecOptions: [],
      msgClass: [0],
      msgSection: [0],
      repObj: {
        type: "",
        dtFrom: "",
        clsIDs: [0],
        secIDs: [0],
        status: [],
        subID: 0,
      },
      repSecOptions: [],
      repClass: [0],
      repSection: [0],
      studentID: null,
      saving: false,
      smartObj: {
        status: "",
        dt: new Date(),
        gr: "",
      },
      sessions: [],
      sessionID: 0,
      subjects: [],
      staffList: [{ id: 0, name: "None" }],
      syncObj: null,
      picObj: null,
      isClasswiseEnrollment: false,
      enLoading: false,
      enrollOptions: [],
      selectedEnroll: null,
      repEnrolled: null,
      dayName: "",
      assignedClasses: [],
      timetableLoading: false,
      selectedAssignedClass: null,
      selectedAssignedIndex: null,
      showReportModal: false,
      otherReportObj: {
        dateFrom: "",
        dateTill: "",
        classIDs: [],
        sectionIDs: [],
        subjectIDs: [],
        studentID: null,
      },
      searchedStudentOptions: [],
      studentSearchLoading: false,
      otherReportItems: [],
      statsLoading: false,
      statsSearchQuery: "",
      statsApplied: false,
      studentDetailsList: [],
      studentDetailsLoading: false,
      selectedAttStudent: null,
      selectedAttSubject: null,
    };
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    async showAttDetails(std, sub) {
      this.selectedAttStudent = std || null;
      this.selectedAttSubject = sub || null;
      this.studentDetailsList = [];
      this.studentDetailsLoading = true;
      this.$bvModal.show("modal-att-details");

      try {
        let classIDs = [];
        if (std && (std.classID || std.clsID || std.cID)) {
          classIDs = [std.classID || std.clsID || std.cID];
        } else if (
          this.otherReportObj.classIDs &&
          this.otherReportObj.classIDs.length
        ) {
          classIDs = this.otherReportObj.classIDs;
        }

        let sectionIDs = [];
        if (std && (std.sectionID || std.secID || std.section)) {
          sectionIDs = [std.sectionID || std.secID || std.section];
        } else if (
          this.otherReportObj.sectionIDs &&
          this.otherReportObj.sectionIDs.length
        ) {
          sectionIDs = this.otherReportObj.sectionIDs;
        }

        let subjectIDs = [];
        if (sub && (sub.subID || sub.id)) {
          subjectIDs = [sub.subID || sub.id];
        } else if (
          this.otherReportObj.subjectIDs &&
          this.otherReportObj.subjectIDs.length
        ) {
          subjectIDs = this.otherReportObj.subjectIDs;
        }

        const payload = {
          classIDs: classIDs,
          sectionIDs: sectionIDs,
          subjectIDs: subjectIDs,
          dateFrom: this.otherReportObj.dateFrom,
          dateTill: this.otherReportObj.dateTill,
          studentID:
            std && (std.sID || std.id)
              ? std.sID || std.id
              : this.otherReportObj.studentID || 0,
        };

        const response = await this.post({
          url:
            this.$store.state.domain +
            "Attendance/LoadStudentDetails?db=" +
            this.$store.state.userData.db +
            "&campusID=" +
            this.$store.state.userData.cId +
            "&cID=" +
            this.$store.state.userData.cId,
          body: payload,
          subjects: true,
          token: this.$store.state.userData.token,
        });

        if (Array.isArray(response)) {
          this.studentDetailsList = response;
        } else if (response && typeof response === "object") {
          this.studentDetailsList = [response];
        } else {
          this.studentDetailsList = [];
        }
      } catch (err) {
        this.$bvToast.toast(
          this.$t("Failed to load student attendance details"),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      } finally {
        this.studentDetailsLoading = false;
      }
    },

    getAttStatusVariant(status) {
      if (!status) return "light-secondary";
      const s = String(status).trim().toLowerCase();
      if (s === "p" || s === "present") return "light-success";
      if (s === "late") return "light-warning";
      if (s === "very late" || s === "verylate" || s === "vl")
        return "light-warning";
      if (s === "a" || s === "absent") return "light-danger";
      if (s === "l" || s === "leave" || s === "e" || s === "excused")
        return "light-info";
      if (s === "h" || s === "holiday") return "light-secondary";
      return "light-primary";
    },

    getAttStatusStyle(status) {
      if (!status) return "";
      const s = String(status).trim().toLowerCase();
      if (s === "late") {
        return "color: #b78103; background-color: rgba(255, 193, 7, 0.15);";
      }
      if (s === "very late" || s === "verylate" || s === "vl") {
        return "color: #ff9f43; background-color: rgba(255, 159, 67, 0.15);";
      }
      return "";
    },

    formatAttStatus(status) {
      if (!status) return "-";
      const s = String(status).trim().toLowerCase();
      if (s === "p" || s === "present") return "Present";
      if (s === "late") return "Late";
      if (s === "very late" || s === "verylate" || s === "vl")
        return "Very Late";
      if (s === "a" || s === "absent") return "Absent";
      if (s === "l" || s === "leave" || s === "e" || s === "excused")
        return "Excused";
      if (s === "h" || s === "holiday") return "Holiday";
      return status;
    },

    getWeekdayKey(dateInput) {
      const date = new Date(dateInput);
      const names = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
      ];
      return names[date.getDay()];
    },
    dtChange() {
      // this.dayName = this.report.dtFrom
      //   ? this.getWeekdayKey(this.report.dtFrom)
      //   : "";
      // if (this.report.dtFrom && this.dayName) {
      //   this.LoadTimetable();
      // }
      if (this.report.dtFrom) {
        this.LoadTimetable();
      }
    },
    async LoadTimetable() {
      this.timetableLoading = true;
      this.selectedAssignedClass = null;
      this.selectedAssignedIndex = null;
      this.showGrid = false;
      this.gridData = [];
      this.assignedClasses = await this.get({
        url:
          this.$store.state.domain +
          "TimeTable/LoadCalendarFilter?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&dt=" +
          this.report.dtFrom,
        token: this.$store.state.userData.token,
      });
      this.timetableLoading = false;
    },
    async selectTimetableClass(record, index) {
      this.selectedAssignedIndex = index;
      this.selectedAssignedClass = record.obj;
      this.loadHappinessGrid();
    },
    async loadHappinessGrid() {
      const tObj = this.selectedAssignedClass;
      if (
        tObj &&
        (tObj.clsID || tObj.clsID == 0) &&
        (tObj.section || tObj.section == 0) &&
        tObj.subID
      ) {
        this.gridLoading = true;
        this.showGrid = true;
        this.report.clsIDs = tObj.clsID == 0 ? [] : [tObj.clsID];
        this.report.secIDs = tObj.section == 0 ? [] : [tObj.section];
        this.report.house = tObj.ageCategory;
        this.report.last_result = tObj.empowerLevel;

        var status = await this.post({
          url:
            this.$store.state.domain +
            "Attendance/LoadAttendanceSubject?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&subID=" +
            tObj.subID +
            "&tID=0",
          body: this.report,
          attendance: true,
          context: this,
          token: this.$store.state.userData.token,
        });

        if (status) {
          this.gridData = status;
          this.sortData();
        }
        this.gridLoading = false;
      }
    },

    getLabel(key) {
      const isHappiness = this.isHappiness;
      const map = {
        class: isHappiness ? "group" : "class",
        classes: isHappiness ? "groups" : "classes",
        section: isHappiness ? "level" : "section",
        sections: isHappiness ? "levels" : "sections",
      };
      const result = map[key.toLowerCase()] ?? key.toLowerCase();
      const isCapitalized =
        key[0] === key[0].toUpperCase() && key[0] !== key[0].toLowerCase();
      return isCapitalized
        ? result.charAt(0).toUpperCase() + result.slice(1)
        : result;
    },

    sortData() {
      this.$store.commit("setAttSort", this.sortBy);

      if (this.sortBy == "gr") {
        this.gridData = this.gridData.sort((a, b) =>
          a.grNo
            .toLowerCase()
            .localeCompare(b.grNo.toLowerCase(), "en", { numeric: true })
        );
      } else {
        this.gridData = this.gridData.sort((a, b) =>
          a.name
            .toLowerCase()
            .localeCompare(b.name.toLowerCase(), "en", { numeric: true })
        );
      }
    },

    async loadOther() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["picture_size", "classwise_enrollment"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      // console.log(res);
      this.picObj = res.find((el) => el.key == "picture_size");
      let obj = res.find((el) => el.key == "classwise_enrollment");
      this.isClasswiseEnrollment = obj && obj.valueBool;
      if (this.isClasswiseEnrollment) {
        this.LoadEnSelection();
        this.fields.splice(5, 0, { label: "time in", key: "timein" });
      }
      // console.log(this.picObj);
    },

    async LoadEnSelection() {
      this.enLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "TeacherClasses/LoadDropdown?db=" +
          this.$store.state.userData.db +
          "&campusID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.enrollOptions = await this.get(obj);
      this.enLoading = false;
      // console.log(this.enrollOptions);
    },
    dropFilter(opt, label, search) {
      // console.log(opt, label, search);
      let st = search.toLowerCase();
      return (
        opt.clsName.toLowerCase().match(st) ||
        opt.secName.toLowerCase().match(st) ||
        opt.subName.toLowerCase().match(st) ||
        opt.name.toLowerCase().match(st)
      );
    },
    resetSelection() {
      if (this.isClasswiseEnrollment) {
        this.selectedEnroll = null;
        this.subID = 0;
        this.tID = 0;
      }
    },

    async loadSessions() {
      var obj = {
        url:
          this.$store.state.domain +
          "Sessions?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.sessions = await this.get(obj);
      this.sessionID = this.sessions.find((el) => el.isCurrentSession)?.id || 0;
    },
    changeAtt(ind, val) {
      if (this.isHappiness && this.filteredAtt[ind].obj.status == val) {
        this.filteredAtt[ind].obj.status = "-";
      } else {
        this.filteredAtt[ind].obj.status = val;
      }
    },
    async save() {
      if (this.gridData.length != 0) {
        this.saving = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Attendance/SaveWebCoaching?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: this.gridData,
          message: "Attendance saved successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.saving = false;
        if (status) {
          if (this.isHappiness) this.loadHappinessGrid();
          else this.loadgrid();
        }
      }
    },
    openDetails() {
      this.showreport = true;
      this.report.type = "student";
      this.showClasses = true;
    },
    setType(val) {
      this.report.type = val;
      if (this.report.type == "student") this.showClasses = true;
      else this.showClasses = false;
    },

    setTime() {
      console.log(this.timePicker);
      console.log(this.datepickr);
    },

    openMessage() {
      this.msgObj = {
        dt: "",
        clsIDs: [0],
        secIDs: [0],
        status: "P",
      };
      this.visibility2 = true;

      var elem = this.$refs["msg_class"];
      elem.state = undefined;
      // var elem = this.$refs["msg_section"];
      // elem.state = undefined;
      var elem = this.$refs["msg_date"];
      elem.state = undefined;
    },

    async saveMessage() {
      // console.log(this.msgObj);
      if (
        this.msgClass.length == 0 ||
        this.msgSection.length == 0 ||
        this.msgObj.dt == ""
      ) {
        return this.$bvToast.toast(
          this.$t("Please select all the required fields"),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      } else {
        if (this.msgClass[0] !== 0) {
          this.msgObj.clsIDs = this.msgClass;
        } else {
          this.msgObj.clsIDs = [];
        }
        if (this.msgSection[0] !== 0) {
          //console.log(this.secID);
          this.msgObj.secIDs = this.msgSection;
        } else {
          this.msgObj.secIDs = [];
        }
        this.request = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Attendance/SendMessage?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: this.msgObj,
          message: "Message send successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        if (status) {
          this.visibility2 = false;
        }
      }
    },
    FillMsgSections() {
      // console.log(this.msgClass);
      if (this.msgClass[0] == 0 && this.msgClass.length !== 1) {
        this.msgClass = this.msgClass.filter((e) => e !== 0);
        // console.log(this.msgClass);
        this.classes.forEach((elem) => {
          if (this.msgClass.includes(elem.cls.id)) {
            if (elem.sections.length != 0) {
              elem.sections.forEach((el) => this.msgSecOptions.push(el));
            } else {
              // console.log("null");
              this.msgSecOptions = [
                { section: "All " + this.getLabel("Sections"), id: 0 },
              ];
            }
          }
        });
      } else if (
        this.msgClass[this.msgClass.length - 1] !== 0 &&
        this.msgClass.length == 1
      ) {
        this.classes.forEach((elem) => {
          if (this.msgClass.includes(elem.cls.id)) {
            if (elem.sections.length != 0) {
              elem.sections.forEach((el) => this.msgSecOptions.push(el));
            } else {
              // console.log("null");
              this.msgSecOptions = [
                { section: "All " + this.getLabel("Sections"), id: 0 },
              ];
            }
          }
        });
      } else if (this.msgClass[this.msgClass.length - 1] == 0) {
        this.msgClass = [0];
        // console.log(this.msgClass);
        this.msgSecOptions = [
          { section: "All " + this.getLabel("Sections"), id: 0 },
        ];
        this.msgSection = [0];
      } else {
        this.msgSecOptions = [
          { section: "All " + this.getLabel("Sections"), id: 0 },
        ];
        this.msgSection = [0];
      }
      // this.CheckClass();
    },
    checkMsgSections() {
      // console.log(this.msgSection);
      if (this.msgSection[0] == 0 && this.msgSection.length !== 1) {
        this.msgSection = this.msgSection.filter((e) => e !== 0);
        // console.log(this.msgSection);
      } else if (this.msgSection[this.msgSection.length - 1] == 0) {
        this.msgSection = [0];
        // console.log(this.msgSection);
      }
    },

    FillSections() {
      //   if (this.classID.includes(0) && this.classID.length == 2) {
      //     this.classID = this.classID.filter((e) => e !== 0);
      //     console.log(this.classID);
      //   }

      // console.log(this.classID);
      if (this.classID[0] == 0 && this.classID.length !== 1) {
        this.classID = this.classID.filter((e) => e !== 0);
        // console.log(this.classID);
        this.classes.forEach((elem) => {
          if (this.classID.includes(elem.cls.id)) {
            if (elem.sections.length != 0) {
              elem.sections.forEach((el) => this.admittedSections.push(el));
            } else {
              // console.log("null");
              this.admittedSections = [
                { section: "All " + this.getLabel("Sections"), id: 0 },
              ];
            }
          }
        });
      } else if (
        this.classID[this.classID.length - 1] !== 0 &&
        this.classID.length == 1
      ) {
        this.classes.forEach((elem) => {
          if (this.classID.includes(elem.cls.id)) {
            if (elem.sections.length != 0) {
              elem.sections.forEach((el) => this.admittedSections.push(el));
            } else {
              // console.log("null");
              this.admittedSections = [
                { section: "All " + this.getLabel("Sections"), id: 0 },
              ];
            }
          }
        });
      } else if (this.classID[this.classID.length - 1] == 0) {
        this.classID = [0];
        // console.log(this.classID);
        this.admittedSections = [
          { section: "All " + this.getLabel("Sections"), id: 0 },
        ];
        this.secID = [0];
      } else {
        this.admittedSections = [
          { section: "All " + this.getLabel("Sections"), id: 0 },
        ];
        this.secID = [0];
      }
      this.resetSelection();
      // this.CheckClass();
    },
    checkSections() {
      // console.log(this.secID);
      if (this.secID[0] == 0 && this.secID.length !== 1) {
        this.secID = this.secID.filter((e) => e !== 0);
        // console.log(this.secID);
      } else if (this.secID[this.secID.length - 1] == 0) {
        this.secID = [0];
        // console.log(this.secID);
      }
      this.resetSelection();
      // this.CheckSec();
    },
    CheckSec() {
      var elem = this.$refs["section"];
      if (this.secID.length == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    FillRepSections() {
      // console.log(this.repClass);
      if (this.repClass[0] == 0 && this.repClass.length !== 1) {
        this.repClass = this.repClass.filter((e) => e !== 0);
        // console.log(this.repClass);
        this.classes.forEach((elem) => {
          if (this.repClass.includes(elem.cls.id)) {
            if (elem.sections.length != 0) {
              elem.sections.forEach((el) => this.repSecOptions.push(el));
            } else {
              // console.log("null");
              this.repSecOptions = [
                { section: "All " + this.getLabel("Sections"), id: 0 },
              ];
            }
          }
        });
      } else if (
        this.repClass[this.repClass.length - 1] !== 0 &&
        this.repClass.length == 1
      ) {
        this.classes.forEach((elem) => {
          if (this.repClass.includes(elem.cls.id)) {
            if (elem.sections.length != 0) {
              elem.sections.forEach((el) => this.repSecOptions.push(el));
            } else {
              // console.log("null");
              this.repSecOptions = [
                { section: "All " + this.getLabel("Sections"), id: 0 },
              ];
            }
          }
        });
      } else if (this.repClass[this.repClass.length - 1] == 0) {
        this.repClass = [0];
        // console.log(this.repClass);
        this.repSecOptions = [
          { section: "All " + this.getLabel("Sections"), id: 0 },
        ];
        this.repSection = [0];
      } else {
        this.repSecOptions = [
          { section: "All " + this.getLabel("Sections"), id: 0 },
        ];
        this.repSection = [0];
      }
      // this.CheckClass();
    },
    checkRepSections() {
      // console.log(this.repSection);
      if (this.repSection[0] == 0 && this.repSection.length !== 1) {
        this.repSection = this.repSection.filter((e) => e !== 0);
        // console.log(this.repSection);
      } else if (this.repSection[this.repSection.length - 1] == 0) {
        this.repSection = [0];
        // console.log(this.repSection);
      }
    },
    setRepDate(sd, dateStr) {
      // console.log(sd, dateStr);
      if (dateStr) {
        if (sd.length > 1) {
          let date = dateStr.split(" to ");
          if (date.length == 1) {
            this.repObj.dtFrom = date[0];
            this.repObj.dtTo = date[0];
          } else {
            this.repObj.dtFrom = date[0];
            this.repObj.dtTo = date[1];
          }
        } else {
          this.repObj.dtFrom = dateStr;
          this.repObj.dtTo = null;
        }
      } else {
        this.repObj.dtFrom = null;
        this.repObj.dtTo = null;
      }
      // console.log(this.repObj);
    },
    setStatus() {
      if (this.repObj.status[this.repObj.status.length - 1] == "") {
        this.repObj.status = [""];
      } else {
        this.repObj.status = this.repObj.status.filter((el) => el != "");
      }
      // console.log(this.repObj.status);
    },
    openReport() {
      if (this.isHappiness) {
        this.$router.push({
          name: "student-attendance-summary",
        });
        // if (!this.otherReportObj.dateFrom || !this.otherReportObj.dateTill) {
        //   const fd = new Date();
        //   const firstDate = `${fd.getFullYear()}-${(fd.getMonth() + 1)
        //     .toString()
        //     .padStart(2, "0")}-01`;
        //   const lastDate = `${fd.getFullYear()}-${(fd.getMonth() + 1)
        //     .toString()
        //     .padStart(2, "0")}-${new Date(
        //     fd.getFullYear(),
        //     fd.getMonth() + 1,
        //     0
        //   )
        //     .getDate()
        //     .toString()
        //     .padStart(2, "0")}`;
        //   this.otherReportObj.dateFrom = firstDate;
        //   this.otherReportObj.dateTill = lastDate;
        // }
        // this.showReportModal = true;
      } else {
        const fd = new Date();
        const firstDate = `${fd.getFullYear()}-${(fd.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-01`;

        const ld = new Date(fd.getFullYear(), fd.getMonth() + 1, 0);
        const lastDate = `${ld.getFullYear()}-${(ld.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${ld.getDate().toString().padStart(2, "0")}`;

        // console.log(firstDate, lastDate);
        this.repObj = {
          type: "",
          dtFrom: firstDate,
          dtTo: lastDate,
          clsIDs: [0],
          secIDs: [0],
          status: [""],
          subID: 0,
        };
        this.repDate = `${firstDate} to ${lastDate}`;

        this.visibility3 = true;

        if (!this.isClasswiseEnrollment) {
          var elem = this.$refs["rep_class"];
          elem.state = undefined;
          // var elem = this.$refs["rep_section"];
          // elem.state = undefined;
        }
        var elem = this.$refs["rep_date"];
        elem.state = undefined;
      }
    },

    async getReport(isExport) {
      // console.log(this.repObj);
      let state =
        this.repClass.length == 0 ||
        this.repSection.length == 0 ||
        this.repObj.status.length == 0 ||
        !this.repObj.dtFrom ||
        !this.repObj.dtTo;

      if (this.isClasswiseEnrollment) {
        state = !this.repEnrolled;
      }

      if (state) {
        return this.$bvToast.toast(
          this.$t("Please select all the required fields"),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      } else {
        if (this.isClasswiseEnrollment) {
          this.repObj.clsIDs = this.repEnrolled.us.cID;
          this.repObj.secIDs = this.repEnrolled.us.section;
          this.repObj.subID = this.repEnrolled.us.subID;
        } else {
          if (this.repClass[0] !== 0) {
            this.repObj.clsIDs = this.repClass;
          } else {
            this.repObj.clsIDs = "";
          }
          if (this.repSection[0] !== 0) {
            this.repObj.secIDs = this.repSection;
          } else {
            this.repObj.secIDs = "";
          }
        }
        let status = "";
        if (this.repObj.status[0] !== "") {
          status = this.repObj.status;
        }
        this.request = true;

        let url =
          `https://${this.reportDomain}.myskool.app/Attendance/` +
          (isExport ? "ShowExport" : "Show") +
          "?type=student&dtFrom=" +
          this.repObj.dtFrom +
          "&dtTo=" +
          this.repObj.dtTo +
          "&dbb=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&cls=" +
          this.repObj.clsIDs +
          "&sec=" +
          this.repObj.secIDs +
          "&status=" +
          status +
          "&subID=" +
          this.repObj.subID;

        if (isExport) {
          this.exporting = true;
          var response = await axios.get(url);
          this.exporting = false;
          if (response.data.status == "success") {
            window.open(response.data.data, "_blank");
          } else {
            this.$bvToast.toast("Something went wrong", {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            });
          }
        } else {
          window.open(url, "_blank");
        }
        this.request = false;
      }
    },
    async getSheet() {
      if (this.repClass.length == 0 || this.repSection.length == 0) {
        return this.$bvToast.toast("Please select class and section", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        if (this.repClass[0] !== 0) {
          this.repObj.clsIDs = this.repClass;
        } else {
          this.repObj.clsIDs = "";
        }
        if (this.repSection[0] !== 0) {
          this.repObj.secIDs = this.repSection;
        } else {
          this.repObj.secIDs = "";
        }

        this.sheetLoading = true;
        if (this.$store.state.currentBranch.organizationType == "coaching") {
          var url =
            `https://${this.reportDomain}.myskool.app/List/Show?type=attendance&dbb=` +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&cls=" +
            this.repObj.clsIDs +
            "&sec=" +
            this.repObj.secIDs +
            "&session=" +
            this.sessionID +
            "&status=&mob=false";

          window.open(url, "_blank");
        } else {
          var url =
            `https://${this.reportDomain}.myskool.app/List/Show?type=attendance&dbb=` +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&cls=" +
            this.repObj.clsIDs +
            "&sec=" +
            this.repObj.secIDs +
            "&status=&mob=false";

          window.open(url, "_blank");
        }
        this.sheetLoading = false;
      }
    },
    async loadgrid() {
      if (
        this.classID.length > 0 &&
        this.secID.length > 0 &&
        this.report.dtFrom
      ) {
        if (this.isClasswiseEnrollment) {
          if (!this.selectedEnroll) {
            this.$bvToast.toast("Please select the subject", {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            });
            return;
          } else {
            this.subID = this.selectedEnroll.us.subID;
            this.tID = this.selectedEnroll.us.tID;
          }
        }
        if (this.subID == 0) {
          this.$bvToast.toast("Please select the subject", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        } else {
          this.gridLoading = true;
          this.showGrid = true;
          if (this.classID[0] !== 0) {
            this.report.clsIDs = this.classID;
          } else {
            this.report.clsIDs = [];
          }
          if (this.secID[0] !== 0) {
            //console.log(this.secID);
            this.report.secIDs = this.secID;
          } else {
            this.report.secIDs = [];
          }

          // console.log(this.report);
          this.request = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Attendance/LoadAttendanceSubject?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId +
              "&subID=" +
              this.subID +
              "&tID=" +
              this.tID,
            body: this.report,
            attendance: true,
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) {
            this.gridData = status;
            this.sortData();
          }
          this.gridLoading = false;
        }
      } else {
        this.$bvToast.toast("Please select all required fields", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },
    async Edit(item) {
      this.attendance = item;
      // console.log(this.attendance);
      this.editAtt = true;
      this.datepickr = this.attendance.date.split("T")[0];
      this.timePicker = this.attendance.date.split("T")[1];

      var elem = this.$refs["account"];
      elem.state = undefined;
      var elem = this.$refs["balance"];
      elem.state = undefined;
    },
    async GetStudent() {
      if (this.studentID.length !== 0) {
        this.studentLoading = true;
        var obj = {
          url:
            this.$store.state.domain +
            "Attendance/LoadStudentData?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&gr=" +
            this.studentID +
            "&userID=" +
            this.$store.state.userData.userID,
          token: this.$store.state.userData.token,
        };
        this.currentStd = await this.get(obj);
        // console.log("res:", this.currentStd);
        this.studentLoading = false;

        if (this.currentStd == "No data found.") {
          this.currentStd = {
            std: {
              picture: null,
              cls: null,
              grNo: null,
              name: null,
            },
            dues: null,
          };
          return this.$bvToast.toast(this.$t("No student found."), {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        } else if (this.currentStd == "Student's profile is not active.") {
          this.currentStd = {
            std: {
              picture: null,
              cls: null,
              grNo: null,
              name: null,
            },
            dues: null,
          };
          return this.$bvToast.toast("Student's profile is not active.", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        } else {
          // this.myObj = this.currentStd.std;
          // console.log("obj:", this.myObj);

          this.items.unshift(this.currentStd);
          // console.log(this.items);
        }
        this.studentID = "";
        if (this.settings.autoHide) {
          setTimeout(() => {
            this.currentStd = {
              std: {
                picture: null,
                cls: null,
                grNo: null,
                name: null,
              },
              dues: null,
            };
            this.studentID = "";
          }, this.settings.hideAfterSeconds * 1000);
        }
      }
    },
    CheckAccount() {
      var elem = this.$refs["account"];
      if (this.myObj.account == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckBalance() {
      var elem = this.$refs["balance"];
      var re = /^[0-9]+$/;
      if (re.test(this.myObj.balance) && this.myObj.balance !== 0) {
        this.myObj.balance = parseInt(this.myObj.balance);
        return (elem.state = true);
      } else {
        return (elem.state = false);
      }
    },

    hideSideBar() {
      this.visibility = false;
    },

    hideAtt() {
      this.editAtt = false;
    },

    showSmart() {
      this.visibility4 = true;
    },
    async saveSmart() {
      if (
        this.smartObj.gr.trim() == "" ||
        !this.smartObj.date ||
        this.smartObj.status == ""
      ) {
        this.$bvToast.toast(this.$t("Please enter the details properly"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.smartObj.gr = this.smartObj.gr.replace(/\n|,/g, " ");
        // console.log(this.smartObj);
        this.request = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Attendance/SmartAttendance?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: this.smartObj,
          message: "Attendance saved successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        if (status) {
          this.visibility4 = false;
        }
      }
    },

    showSettings() {
      this.visibility = true;
    },
    async LoadSettings() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "AttendanceSettings/LoadData?campusID=" +
          this.$store.state.userData.cId +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      };
      let result = await this.get(obj);
      this.dataLoading = false;
      if (result == null) {
        this.settings = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          notifyArrival: false,
          notifyDeparture: false,
          showDues: false,
          showRecent: false,
          autoHide: false,
          hideAfterSeconds: 5,
          attendanceMode: "",
        };
      } else {
        this.settings = result;
      }
      // console.log("set", this.settings);
    },
    async loadStaff() {
      this.tID = 0;
      this.staffList = [{ id: 0, name: "None" }];

      let myitem = await this.get({
        url:
          this.$store.state.domain +
          "Subjects/LoadTeacherBySubjects?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&subjectID=" +
          this.subID,
        token: this.$store.state.userData.token,
      });
      this.staffList = [{ id: 0, name: "None" }, ...myitem];
    },
    async LoadSubjects() {
      var obj = {
        url:
          this.$store.state.domain +
          "Subjects?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.subjects = await this.get(obj);

      // console.log("subject", this.items);
    },
    async LoadClasses() {
      var obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      this.classes = await this.get(obj);
      // console.log("class", this.classes);
      this.classes.forEach((el) => {
        this.classesOptions.push(el.cls);
      });
    },
    async saveSettings() {
      this.request = true;
      let x = parseInt(this.settings.hideAfterSeconds);
      this.settings.hideAfterSeconds = !x ? 5 : x;

      var status = await this.post({
        url:
          this.$store.state.domain +
          "AttendanceSettings/Save?db=" +
          this.$store.state.userData.db,
        body: this.settings,
        message: "Settings saved successfully.",
        context: this,
        token: this.$store.state.userData.token,
      });
      this.request = false;
      if (status) {
        this.visibility = false;
        this.LoadSettings();
      }
    },
    async saveAttendance() {
      this.request = true;
      // this.attendance.obj.date = this.datepickr + this.timePicker;
      this.attendance.obj.date = new Date().toJSON();
      var status = await this.put({
        url:
          this.$store.state.domain +
          "Attendance/id=" +
          this.attendance.obj.id +
          "?db=" +
          this.$store.state.userData.db,
        body: this.attendance.obj,
        message: "Attendance updated successfully.",
        context: this,
        token: this.$store.state.userData.token,
      });
      this.request = false;
      if (status) {
        this.editAtt = false;
        if (this.isHappiness) this.loadHappinessGrid();
        else this.loadgrid();
      }
    },
    onModalClassChange() {
      if (
        this.otherReportObj.sectionIDs &&
        this.otherReportObj.sectionIDs.length
      ) {
        const validSectionIds = this.modalSectionOptions.map((s) => s.id);
        this.otherReportObj.sectionIDs = this.otherReportObj.sectionIDs.filter(
          (id) => validSectionIds.includes(id)
        );
      }
    },
    async onStatsStudentSearch(search, loading) {
      if (!search || search.trim().length < 2) {
        return;
      }
      if (typeof loading === "function") loading(true);
      this.studentSearchLoading = true;
      try {
        const obj = {
          url:
            this.$store.state.domain +
            "Students/Search?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&keyword=" +
            encodeURIComponent(search.trim()) +
            "&type=",
          token: this.$store.state.userData.token,
        };
        const response = await this.get(obj);
        let data = [];
        if (response && response.data && Array.isArray(response.data)) {
          data = response.data;
        } else if (Array.isArray(response)) {
          data = response;
        }
        this.searchedStudentOptions = data.map((s) => {
          let className = "";
          let sectionName = "";
          if (s.meta_class) {
            const parts = s.meta_class.split(" - ");
            className = parts[0] ? parts[0].trim() : "";
            sectionName = parts[1] ? parts[1].trim() : "";
          }
          const gr = s.grNo || s.grno || s.gr || "";
          const cls = className || s.className || "";
          const sec = sectionName || s.sectionName || "";
          const father = s.father_name || s.fatherName || "";
          let label = s.name || "";
          if (gr) label += ` (GR# ${gr})`;
          if (cls) label += ` - ${cls}${sec ? " (" + sec + ")" : ""}`;

          return {
            id: s.id,
            name: s.name || "",
            label,
            className: cls,
            sectionName: sec,
            grNo: gr,
            father_name: father,
          };
        });
      } catch (err) {
        console.error("Error searching students:", err);
      } finally {
        if (typeof loading === "function") loading(false);
        this.studentSearchLoading = false;
      }
    },
    resetStatsFilter() {
      const fd = new Date();
      const firstDate = `${fd.getFullYear()}-${(fd.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-01`;
      const lastDate = `${fd.getFullYear()}-${(fd.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${new Date(fd.getFullYear(), fd.getMonth() + 1, 0)
        .getDate()
        .toString()
        .padStart(2, "0")}`;
      this.otherReportObj = {
        dateFrom: firstDate,
        dateTill: lastDate,
        classIDs: [],
        sectionIDs: [],
        subjectIDs: [],
        studentID: null,
      };
      this.searchedStudentOptions = [];
      this.otherReportItems = [];
      this.statsApplied = false;
      this.statsSearchQuery = "";
    },
    async loadAttendanceStats() {
      if (!this.otherReportObj.dateFrom || !this.otherReportObj.dateTill) {
        this.$bvToast.toast(this.$t("Please select Date From and Date Till"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      this.statsLoading = true;
      this.statsApplied = true;
      try {
        const payload = {
          classIDs: this.otherReportObj.classIDs || [],
          sectionIDs: this.otherReportObj.sectionIDs || [],
          subjectIDs: this.otherReportObj.subjectIDs || [],
          dateFrom: this.otherReportObj.dateFrom,
          dateTill: this.otherReportObj.dateTill,
          studentID: this.otherReportObj.studentID || 0,
        };

        const response = await this.post({
          url:
            this.$store.state.domain +
            "Attendance/LoadStats?db=" +
            this.$store.state.userData.db +
            "&campusID=" +
            this.$store.state.userData.cId +
            "&cID=" +
            this.$store.state.userData.cId,
          body: payload,
          subjects: true,
          token: this.$store.state.userData.token,
        });

        this.otherReportItems = Array.isArray(response) ? response : [];
        if (!this.otherReportItems.length) {
          this.$bvToast.toast(
            this.$t("No attendance records found for the selected filter"),
            {
              title: this.$t("Info"),
              variant: "info",
              toaster: "b-toaster-top-center",
            }
          );
        }
      } catch (err) {
        this.$bvToast.toast(this.$t("Failed to load attendance summary"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.statsLoading = false;
      }
    },
    getStudentOverallPercentage(student) {
      if (!student.subjects || !student.subjects.length) return 0;
      let totalP = 0;
      let totalCount = 0;
      student.subjects.forEach((s) => {
        totalP += Number(s.p || s.P || 0);
        totalCount += Number(s.total || s.Total || 0);
      });
      if (!totalCount) return 0;
      return Math.round((totalP / totalCount) * 100);
    },
    getPercentageBadgeVariant(perc) {
      if (perc >= 80) return "light-success";
      if (perc >= 60) return "light-warning";
      return "light-danger";
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.attendance-stats-dialog {
  max-width: 94% !important;
  width: 94% !important;
  margin-left: auto !important;
  margin-right: auto !important;
}
</style>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}

.card {
  transition: 0.4s;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.card-body {
  padding: 0.85rem;
}

@keyframes myfade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.set-picSize {
  width: 180px !important;
  height: 180px !important;
}

.attendance-class-card {
  border: 1.5px solid #ebe9f1 !important;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.attendance-class-card.selected {
  border-color: #836af9 !important;
}

.attendance-class-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.attendance-class-card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.student-stats-card {
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.2s ease-in-out;
}

.student-stats-card:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08) !important;
}

.stats-search-input {
  border-radius: 6px;
}

.attendance-stats-modal-body {
  max-height: calc(85vh - 120px) !important;
  overflow-y: auto !important;
}

.attendance-stats-list {
  max-height: 52vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
}
</style>
